import { getFutureDate } from '../../../utils/dateFunctions';
import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import { getNowDateOrEarlierMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry, initialState) => {
    let newErrors = {};

    if (newEntry?.eoiCompletionDate && getFutureDate(newEntry.eoiCompletionDate)) {
        newErrors = {
            ...newErrors,
            eoiCompletionDate: {
                error: true,
                message: getNowDateOrEarlierMessage()
            }
        };
    }

    if (Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};
